import instance from '../instance';
import getLiveElement from '../accessors/get-live-element';
import getStaticElement from '../accessors/get-static-element';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';
import { UPDATE_BOTH, UPDATE_STATIC_ONLY } from '../constants/update-strategies';

const setElementAttribute = (elementId, attr, value, updateStrategy = UPDATE_BOTH) => {
  if (updateStrategy === UPDATE_STATIC_ONLY) {
    /**
     * We need to handle static-only strategy this way
     * because static element might have a virtual reference.
     *
     * Virtual references helps to apply operations on static nodes
     * before their live copies being inserted.
     */
    const element = getStaticElement(elementId);
    instance.driver.setStaticElementAttribute(element, attr, value);
  } else {
    const element = getLiveElement(elementId);
    instance.driver.setElementAttribute(element, attr, value, updateStrategy);
  }

  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);

  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default setElementAttribute;
